import React, { useState, useEffect } from "react";

const CreateLeadOthersForm = ({
  mode,
  formData,
  setFormData,
  handleChange,
  sectionsRef,
}) => {
  const [planningAbroad, setPlanningAbroad] = useState(false);

  useEffect(() => {
    if (formData.study_abroad !== undefined && formData.study_abroad !== null) {
      if (formData.study_abroad !== "No") {
        setPlanningAbroad(true);
      } else {
        setPlanningAbroad(false);
      }
    }
  }, [formData.study_abroad]);

  const handleRadioChange = (isYes) => {
    setPlanningAbroad(isYes);
    if (!isYes) {
      setFormData((prev) => ({ ...prev, study_abroad: "No" }));
    } else {
      setFormData((prev) => ({ ...prev, study_abroad: "" }));
    }
  };
  return (
    <>
      <div
        className="p-6 border-b-2 border-gray-300"
        ref={sectionsRef.educationCareer}
        id="educationCareer"
      >
        <h2 className="text-lg font-semibold text-purple-700 mb-4">
          Session & Qualification Details
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Session Type */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Session Type
            </label>
            {mode === "view" ? (
              <p className="text-gray-600 font-medium">
                {formData.session_type || "Not specified"}
              </p>
            ) : (
              <select
                name="session_type"
                value={formData.session_type || ""}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500 bg-white"
              >
                <option value="">Select Session Type</option>
                <option value="College Selection">College Selection</option>
                <option value="Follow up">Follow up</option>
                <option value="School/Board Selection">School/Board Selection</option>
              </select>
            )}
          </div>

          {/* Current/Past Qualification */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Current/Past Qualification
            </label>
            {mode === "view" ? (
              <p className="text-gray-600">
                {formData.current_qualification || "Not specified"}
              </p>
            ) : (
              <input
                type="text"
                name="current_qualification"
                value={formData.current_qualification || ""}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                placeholder="Enter qualification"
              />
            )}
          </div>

          {/* Place of Residence */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Place of Residence
            </label>
            {mode === "view" ? (
              <p className="text-gray-600">
                {formData.place_of_residence || "Not specified"}
              </p>
            ) : (
              <input
                type="text"
                name="place_of_residence"
                value={formData.place_of_residence || ""}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                placeholder="Enter place of residence"
              />
            )}
          </div>

          {/* School/College Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              School/College Name
            </label>
            {mode === "view" ? (
              <p className="text-gray-600">
                {formData.school_college_name || "Not specified"}
              </p>
            ) : (
              <input
                type="text"
                name="school_college_name"
                value={formData.school_college_name || ""}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                placeholder="Enter school/college name"
              />
            )}
          </div>

          {/* GPA/Percentage obtained */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              GPA/Percentage obtained
            </label>
            {mode === "view" ? (
              <p className="text-gray-600">
                {formData.gpa_percentage || "Not specified"}
              </p>
            ) : (
              <input
                type="text"
                name="gpa_percentage"
                value={formData.gpa_percentage || ""}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                placeholder="Enter GPA/Percentage"
              />
            )}
          </div>

          {/* Study Abroad Planning */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2 font-semibold">
              Are you planning to study abroad?
            </label>
            {mode === "view" ? (
              <p className="text-gray-600">
                {!formData.study_abroad || formData.study_abroad === "No"
                  ? "No"
                  : `Yes (Country: ${formData.study_abroad})`}
              </p>
            ) : (
              <div className="flex flex-col gap-2">
                <div className="flex gap-4">
                  <label className="inline-flex items-center cursor-pointer">
                    <input
                      type="radio"
                      name="study_abroad_radio"
                      checked={planningAbroad}
                      onChange={() => handleRadioChange(true)}
                      className="border-gray-300 text-purple-600 focus:ring-purple-500 h-4 w-4"
                    />
                    <span className="ml-2 text-sm text-gray-700">Yes</span>
                  </label>
                  <label className="inline-flex items-center cursor-pointer">
                    <input
                      type="radio"
                      name="study_abroad_radio"
                      checked={!planningAbroad}
                      onChange={() => handleRadioChange(false)}
                      className="border-gray-300 text-purple-600 focus:ring-purple-500 h-4 w-4"
                    />
                    <span className="ml-2 text-sm text-gray-700">No</span>
                  </label>
                </div>

                {planningAbroad && (
                  <input
                    type="text"
                    name="study_abroad"
                    value={formData.study_abroad === "No" ? "" : formData.study_abroad || ""}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500 mt-1"
                    placeholder="Which country?"
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        className="p-6 border-b-2 border-gray-300"
        ref={sectionsRef.selfDescription}
        id="selfDescription"
      >
        <h2 className="text-lg font-semibold text-purple-700 mb-4">
          Experience & Expectations
        </h2>
        <div className="grid grid-cols-1 gap-4">
          {/* Work Experience */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Work Experience (if any)
            </label>
            {mode === "view" ? (
              <p className="text-gray-600 whitespace-pre-wrap">
                {formData.work_experience || "None specified"}
              </p>
            ) : (
              <textarea
                name="work_experience"
                value={formData.work_experience || ""}
                onChange={handleChange}
                rows={3}
                className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                placeholder="Enter work experience"
              />
            )}
          </div>

          {/* Extra Curriculars / Other Info */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Other Information (Extra curriculars, Internships, Interests, Hobbies)
            </label>
            {mode === "view" ? (
              <p className="text-gray-600 whitespace-pre-wrap">
                {formData.extra_information || "None specified"}
              </p>
            ) : (
              <textarea
                name="extra_information"
                value={formData.extra_information || ""}
                onChange={handleChange}
                rows={3}
                className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                placeholder="Enter extra curriculars, hobbies, etc."
              />
            )}
          </div>

          {/* Expectations */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2 font-semibold">
              Expectations from counseling session
            </label>
            {mode === "view" ? (
              <p className="text-gray-600 whitespace-pre-wrap">
                {formData.expectations || "None specified"}
              </p>
            ) : (
              <textarea
                name="expectations"
                value={formData.expectations || ""}
                onChange={handleChange}
                rows={3}
                className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                placeholder="Enter expectations"
              />
            )}
          </div>


        </div>
      </div>
    </>
  );
};

export default CreateLeadOthersForm;
